import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import usePageTitle from "@/lib/usePageTitle";

const statusColor = {
  ongoing: "bg-secondary text-secondary-foreground",
  completed: "bg-primary/15 text-primary",
  planned: "bg-accent/20 text-accent-foreground",
};

const Projects = () => {
  usePageTitle("Projects");
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="container-le section-pad" data-testid="projects-page">
      <div className="max-w-2xl mb-12">
        <div className="text-xs uppercase tracking-[0.25em] text-secondary mb-3">Township Work</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight">Projects</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Ongoing initiatives and completed work across Lake Eunice Township.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {items.map((p) => (
          <Card key={p.id} className="border-border" data-testid={`project-${p.id}`}>
            <CardContent className="p-7">
              <div className="flex items-center justify-between mb-3">
                <Badge className={statusColor[p.status] || "bg-muted text-foreground"}>{p.status}</Badge>
                {p.year && <span className="text-xs text-muted-foreground tracking-wide">{p.year}</span>}
              </div>
              <div className="font-heading text-xl font-semibold">{p.title}</div>
              <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{p.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Projects;
